import { useState } from "react";

export const Artists = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="artists-page">
      {/* Hero Section */}
      <section className="relative py-20 md:py-32">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-[0.625rem] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-6 animate-fade-in">
              The Creators
            </p>
            <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.9] mb-6 animate-fade-in-up">
              <span className="gold-gradient">Our Artists</span>
            </h1>
            <div className="w-16 h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mx-auto mb-6" />
            <p className="text-base md:text-lg text-white/80 font-light leading-relaxed animate-fade-in-up-delay-1">
              Meet the talented artists behind the exquisite designs that make each Goldnote a masterpiece.
            </p>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="py-24">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto text-center">
            {/* Coming Soon Badge */}
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full mb-8">
              <span className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" />
              <span className="text-[0.7rem] tracking-[0.2em] uppercase text-[#D4AF37]">Coming Soon</span>
            </div>
            
            <h2 className="text-2xl md:text-3xl text-white/90 mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
              Artist Profiles In Development
            </h2>
            
            <p className="text-white/70 font-light leading-relaxed mb-8">
              We're preparing detailed profiles of the master engravers, designers, and artists who bring 
              our Goldnotes to life. Each piece tells a story of craftsmanship, heritage, and artistic vision.
            </p>
            
            <div className="p-8 bg-[#0A0A0A] border border-[#D4AF37]/20 rounded-xl">
              <p className="text-sm text-white/80 mb-4">
                Be the first to discover the stories behind our designs
              </p>
              <div className="flex items-center justify-center gap-3">
                <input 
                  type="email" 
                  placeholder="Enter your email"
                  className="px-4 py-3 bg-[#121212] border border-white/10 rounded-lg text-white placeholder:text-white/30 focus:border-[#D4AF37]/50 focus:outline-none w-64"
                />
                <button className="px-6 py-3 bg-[#D4AF37] text-[#050505] hover:bg-[#EEDC9A] text-xs tracking-[0.15em] uppercase font-medium rounded-lg transition-colors">
                  Notify Me
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Decorative Section */}
      <section className="py-16 bg-[#0A0A0A]">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center p-6">
              <div className="w-16 h-16 mx-auto mb-4 border border-[#D4AF37]/30 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                </svg>
              </div>
              <h3 className="text-white/90 mb-2">Master Engravers</h3>
              <p className="text-xs text-white/70 font-light">
                Traditional techniques meet modern precision
              </p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 mx-auto mb-4 border border-[#D4AF37]/30 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-white/90 mb-2">Visual Designers</h3>
              <p className="text-xs text-white/70 font-light">
                Creating iconic imagery for each edition
              </p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 mx-auto mb-4 border border-[#D4AF37]/30 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-white/90 mb-2">Creative Directors</h3>
              <p className="text-xs text-white/70 font-light">
                Visionaries shaping the future of gold
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Artists;
